import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from "react-router";

import { store, history } from './store'
import App from './App';
import './index.css';



ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root'),
)




// WEBPACK FOOTER //
// ./src/index.tsx